'use client';

import MuiButton from '@mui/material/Button';
import Link from 'next/link';

/**
 * Botón del sistema. variantes:
 *   solid  → dorado relleno (CTA principal)
 *   ghost  → borde, texto claro (CTA secundario sobre navy)
 *   link   → solo texto dorado
 *
 * href interno → next/link. href + external → <a> normal.
 */
export default function Button({
  children,
  variant = 'solid',
  href,
  external = false,
  onClick,
  size = 'medium',
  fullWidth = false,
  className = '',
  ...props
}) {
  const muiVariant =
    variant === 'ghost'
      ? 'outlined'
      : variant === 'link'
        ? 'text'
        : 'contained';

  const linkProps =
    href && !external
      ? { component: Link, href }
      : href
        ? {
            href,
            target: props.target,
            rel: props.rel || 'noopener noreferrer',
          }
        : {};

  return (
    <MuiButton
      variant={muiVariant}
      color="primary"
      onClick={onClick}
      size={size}
      fullWidth={fullWidth}
      className={className}
      disableRipple
      {...linkProps}
      {...props}
    >
      {children}
    </MuiButton>
  );
}
